import detailDefault from '../../detailDefault';
export default class detailaon_portal_documents extends detailDefault {
    load(sAction, data) {

    }

    update(sAction, data) {

    }

    beforeSave(sAction, data) {
        return true;
    }
}
